module.exports = __webpack_public_path__ + "img/12_109.2abc8999.png";